import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ColorSchemeUserSetting } from "abreact/app/settings/ColorSchemeUserSetting";
import { FontSizeUserSetting } from "abreact/app/settings/FontSizeUserSetting";
import { LanguageUserSetting } from "abreact/app/settings/LanguageUserSetting";
import { UserSettingsService } from "abweb/service/settings/UserSettingsService";
export class BuiltInUserSettings {
  static registerSettings() {
    UserSettingsService.userSettings.registry.register(() => this.language).register(() => this.fontSize).register(() => this.colorScheme);
  }
}
_defineProperty(BuiltInUserSettings, "language", new LanguageUserSetting());
_defineProperty(BuiltInUserSettings, "fontSize", new FontSizeUserSetting());
_defineProperty(BuiltInUserSettings, "colorScheme", new ColorSchemeUserSetting());
//# sourceMappingURL=BuiltInUserSettings.js.map
